import React from 'react';
import { GameCard } from './GameCard';

export const MathsGames: React.FC = () => {
  const games = [
    {
      name: 'Factor Detective',
      description: 'Investigate factors and multiples to solve number mysteries',
      subject: 'Mathematics',
      color: '#4558C8',
      topics: ['Number and Place Value', 'Factors', 'Multiples']
    },
    {
      name: 'Money Manager',
      description: 'Plan budgets and manage finances in real-world scenarios',
      subject: 'Mathematics',
      color: '#4558C8',
      topics: ['Financial Mathematics', 'GST', 'Budgeting']
    },
    {
      name: 'Algebra Adventures',
      description: 'Solve pattern puzzles with fractions and decimals',
      subject: 'Mathematics',
      color: '#4558C8',
      topics: ['Patterns', 'Algebra', 'Number Sequences']
    },
    {
      name: 'Measure Master',
      description: 'Master measurements in virtual real-world challenges',
      subject: 'Mathematics',
      color: '#4558C8',
      topics: ['Measurement', 'Time', 'Area and Volume']
    }
  ];

  return (
    <div className="space-y-6">
      <h2 className="text-[68px] tracking-tighter text-[#292B2D]">
        Maths Games
      </h2>
      
      <div className="grid grid-cols-4 gap-6 max-md:grid-cols-2 max-sm:grid-cols-1">
        {games.map((game, index) => (
          <GameCard key={index} game={game} index={index} />
        ))}
      </div>
    </div>
  );
};